
import { useState } from 'react';

interface SearchInputProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  className?: string;
}

export default function SearchInput({ onSearch, placeholder = "Search...", className = "" }: SearchInputProps) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(query);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    // Trigger search on every keystroke for real-time filtering
    onSearch(value);
  };

  return (
    <form onSubmit={handleSubmit} className={`relative ${className}`}>
      <div className="relative">
        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          placeholder={placeholder}
          className="w-full bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-6 py-4 pl-14 text-white placeholder-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-lg"
        />
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
          <i className="ri-search-line text-slate-300 text-xl w-6 h-6 flex items-center justify-center"></i>
        </div>
        {query && (
          <button
            type="button"
            onClick={() => {
              setQuery('');
              onSearch('');
            }}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-300 hover:text-white cursor-pointer"
          >
            <i className="ri-close-line text-xl w-6 h-6 flex items-center justify-center"></i>
          </button>
        )}
      </div>
    </form>
  );
}
